import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AuthLayout } from '@/components/auth/AuthLayout';
import { MagicLinkForm } from '@/components/auth/MagicLinkForm';

const searchSchema = z.object({
  redirect: z.string().optional(),
});

export const Route = createFileRoute('/sign-in')({
  validateSearch: searchSchema,
  component: SignInPage,
});

function SignInPage() {
  const { redirect } = Route.useSearch();
  return (
    <AuthLayout
      eyebrow="Sign in"
      title="Welcome back."
      subtitle="Enter your email and we'll send a one-time sign-in link. No passwords, ever."
    >
      <MagicLinkForm intent="sign-in" redirectTo={redirect ?? '/app'} />
    </AuthLayout>
  );
}
